/* eslint-disable import/prefer-default-export */
export const NOTIFICATION_EXTRA_TYPES = ['message', 'question', 'rating'];
